import React from 'react';
// import LogoImage from '../assets/logo_image.png';
import LogoImage from '../assets/linked2Checkout.png';

const LogoGhl = () => {
  return <img src={LogoImage} alt="" className="imageLogo" />
}

export default LogoGhl;